import { ReactHtmlProps } from './types'
import { customParse } from '../../utils/helper-util'
import { getSpacing } from '../../utils/spacing-util'
import IsInEditorText from '../shared/IsInEditorText'

const ReactHtml = (props: ReactHtmlProps): JSX.Element => {
  const { isInEditor = false, id, html, lob = '', top = false, right = false, bottom = false, left = false } = props
  return (
    <>
      {IsInEditorText(isInEditor, 'React Html Code Block')}
      <div id={id} data-testid='react-html' className={`${getSpacing(top, right, bottom, left)} ${lob}`}>
        {customParse(html, true)}
      </div>
    </>
  )
}

export default ReactHtml
